import { BfPageStoreProvider, useStoreState } from '@tw/tw-runtime-react';
/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import React, { useEffect, useState } from 'react';
import { Text, View } from 'react-native';
import { TwColumn, TwFormItem, TwPage, TwPageHeader, TwRow } from '@tw/tw-components-rn';
import { TwTcCommodityAddress, TwTcCommodityCardInfo, TwTpOrderInfo } from '@tw/tw-templates-rn';

import { Divider } from 'native-base';
import { ElementUtils } from '@tw/tw-platform-react';
import { ScrollView } from 'react-native-gesture-handler';
import { SettingHistoryOrderNewStore } from '@/setting/stores/history-order-new/setting-history-order-new-store';
import { styles } from './styles';
import { getStatusColor } from '@/gift/pages/gift-shopping/GiftGiftShopping';

const dayjs = require('dayjs');

export const SettingHistoryOrderInfo = (props) => {
  const [store] = useState(SettingHistoryOrderNewStore.getInstance());
  const datas = useStoreState(store, (state) => state.datas);
  const [orderGoodsTreeData, setOrderGoodsTreeData] = useState(null);

  useEffect(() => {
    async function fetchData() {
      // You can await here
      const orderDetail = await store.onLoadOrder(props.route.params.orderId);
      setOrderGoodsTreeData(orderDetail);
    }
    fetchData();
  }, [props.route.params.orderId]);

  if (!orderGoodsTreeData) {
    return null;
  }

  const data = datas.find((item) => item.order.id === props.route.params.orderId);
  if (!data) {
    return null;
  }

  // console.log('====data ', data, orderGoodsTreeData);

  // const amount = data.goodsInfo.reduce((pre, cur) => {
  //   return pre + cur.price * cur.num;
  // }, 0);

  return (
    <BfPageStoreProvider store={store}>
      <TwPage translucentStatusBar={true}>
        <TwPage.Header title={'历史订单'}></TwPage.Header>
        <ScrollView style={{ height: '100%' }}>
          <TwTpOrderInfo
            address={{
              icon: 'icon-add-print',
              title: ElementUtils.getTextDirectly(data.order.address, 'coordinates'),
              state: '下单时间',
              name: data.order.linkman,
              mobile: data.order.linkmanPhone,
              createdTime: data.order.createTime
            }}
            orderData={orderGoodsTreeData?.map((item) => {
              return {
                storeName: item.supplierData.name,
                orderStatus: item.status.name,
                statusColor: getStatusColor(item.status.code),
                trackingNumber: item.courierNumber ? item.courierNumber.split(',') : undefined,
                commodity: item.children.map((goods) => {
                  return {
                    title: goods.goodsData.name,
                    // TODO: 缺少字段
                    subTitle: '', //goods.goodsData.desc,
                    price: goods.goodsData.price,
                    num: goods.goodsData.num,
                    imageUrl: goods.goodsData.showPicture?.url || '',
                    onPress: () => {
                      store.onGoodClick(goods.goodsData.goodsId.id, 'view');
                    }
                  };
                })
              };
            })}
          />
        </ScrollView>
      </TwPage>
    </BfPageStoreProvider>
  );
};
